<div>
   <div class="heading">
      <h3>File Claim Details</h3>
      <span (click)="onNoClick()"><mat-icon>close</mat-icon></span>
   </div>
   <mat-dialog-content>
      <div class="info">
         <h3>Personal Information</h3>
         <div class="labeldetail">
             <label>First Name:</label> {{claimDetails?.firstName}}
         </div>
         <div class="labeldetail">
             <label>Last Name:</label>  {{claimDetails?.lastName}}
         </div>
         <div class="labeldetail">
             <label>Phone No:</label>  {{claimDetails?.phoneNumber | mask : "(000) 000-0000"}}
         </div>
         <div class="labeldetail">
             <label>Email Address:</label> {{claimDetails?.emailAddress}}
         </div>
     </div>
     <div class="info">
         <h3>Location Information</h3>
         <div class="labeldetail">
            <label>Address:</label> {{claimDetails?.propertyAddress?.address}}
         </div>
         <div class="labeldetail">
            <label>City:</label>  {{claimDetails?.propertyAddress?.city}}
         </div>
         <div class="labeldetail">
            <label>State:</label>  {{claimDetails?.propertyAddress?.state}}
         </div>
         <div class="labeldetail">
            <label>Zip:</label> {{claimDetails?.propertyAddress?.zip}}
         </div>
      </div>
      <div class="info">
         <h3>Claim Information</h3>
         <div class="labeldetail">
            <label>Claim Number:</label> {{claimDetails?.fileClaimNumber}}
         </div>
         <div class="labeldetail">
            <label>Claim Status:</label> {{claimDetails?.status}}
         </div>
         <div class="labeldetail">
            <label>Agreement Number:</label> {{claimDetails?.agreementDetail?.agreementNumber}}
        </div>
     </div>
     <div class="info" *ngIf="claimDetails?.additionalInfo?.assignedConcierge">
      <h3>Assigned Concierge</h3>
      <div class="labeldetail">
         <label>Concierge Name:</label> {{claimDetails?.additionalInfo?.assignedConcierge?.firstName}} {{claimDetails?.additionalInfo?.assignedConcierge?.lastName}}
      </div>
         <div class="labeldetail">
            <label>Email Address:</label> {{claimDetails?.additionalInfo?.assignedConcierge?.emailAddress}}
         </div>
         <div class="labeldetail">
            <label>Phone Number:</label> {{claimDetails?.additionalInfo?.assignedConcierge?.phoneNumber | mask : "(000) 000-0000"}}
         </div>
     </div>
     <div class="info" *ngIf="claimDetails?.additionalInfo?.assignedCoordinator">
      <h3>Assigned Coordinator</h3>
      <div class="labeldetail">
         <label>Coordinator Name:</label> {{claimDetails?.additionalInfo?.assignedCoordinator?.firstName}} {{claimDetails?.additionalInfo?.assignedCoordinator?.lastName}}
      </div>
         <div class="labeldetail">
            <label>Email Address:</label> {{claimDetails?.additionalInfo?.assignedCoordinator?.emailAddress}}
         </div>
         <div class="labeldetail">
            <label>Phone Number:</label> {{claimDetails?.additionalInfo?.assignedCoordinator?.phoneNumber | mask : "(000) 000-0000"}}
         </div>
     </div>
     <div class="info" *ngIf="claimDetails?.additionalInfo?.assignedCurrentUser">
      <h3>Assigned Current User</h3>
      <div class="labeldetail">
         <label>Current User Name:</label> {{claimDetails?.additionalInfo?.assignedCurrentUser?.firstName}} {{claimDetails?.additionalInfo?.assignedCurrentUser?.lastName}}
      </div>
         <div class="labeldetail">
            <label>Email Address:</label> {{claimDetails?.additionalInfo?.assignedCurrentUser?.emailAddress}}
         </div>
         <div class="labeldetail">
            <label>Phone Number:</label> {{claimDetails?.additionalInfo?.assignedCurrentUser?.phoneNumber | mask : "(000) 000-0000"}}
         </div>
     </div>
     <div class="info" *ngIf="claimDetails?.additionalInfo?.assignedFollowUpAgent">
      <h3>Assigned Follow Up Agent</h3>
      <div class="labeldetail">
         <label>Follow Up Agent Name:</label> {{claimDetails?.additionalInfo?.assignedFollowUpAgent?.firstName}} {{claimDetails?.additionalInfo?.assignedFollowUpAgent?.lastName}}
      </div>
         <div class="labeldetail">
            <label>Email Address:</label> {{claimDetails?.additionalInfo?.assignedFollowUpAgent?.emailAddress}}
         </div>
         <div class="labeldetail">
            <label>Phone Number:</label> {{claimDetails?.additionalInfo?.assignedFollowUpAgent?.phoneNumber | mask : "(000) 000-0000"}}
         </div>
     </div>
     <div class="info" *ngIf="claimDetails?.additionalInfo?.assignedSupervisor">
      <h3>Assigned Supervisor</h3>
      <div class="labeldetail">
         <label>Supervisor Name:</label> {{claimDetails?.additionalInfo?.assignedSupervisor?.firstName}} {{claimDetails?.additionalInfo?.assignedSupervisor?.lastName}}
      </div>
         <div class="labeldetail">
            <label>Email Address:</label> {{claimDetails?.additionalInfo?.assignedSupervisor?.emailAddress}}
         </div>
         <div class="labeldetail">
            <label>Phone Number:</label> {{claimDetails?.additionalInfo?.assignedSupervisor?.phoneNumber | mask : "(000) 000-0000"}}
         </div>
     </div>
     <div class="info" *ngIf="claimDetails?.additionalInfo?.assignedTechnician">
      <h3>Assigned Technician</h3>
      <div class="labeldetail">
         <label>Technician Name:</label> {{claimDetails?.additionalInfo?.assignedTechnician?.firstName}} {{claimDetails?.additionalInfo?.assignedTechnician?.lastName}}
      </div>
         <div class="labeldetail">
            <label>Email Address:</label> {{claimDetails?.additionalInfo?.assignedTechnician?.emailAddress}}
         </div>
         <div class="labeldetail">
            <label>Phone Number:</label> {{claimDetails?.additionalInfo?.assignedTechnician?.phoneNumber | mask : "(000) 000-0000"}}
         </div>
     </div>
      <div class="info">
         <h3>Payment Information</h3>
         <div class="labeldetail" *ngIf="claimDetails?.parentCoveredItem">
            <label>Parent Cover Item:</label> {{claimDetails?.parentCoveredItem}}
         </div>
         <div class="labeldetail">
            <label>Cover Item:</label>  {{claimDetails?.coveredItem}}
         </div>
         <div class="labeldetail">
            <label>Availability:</label>  {{claimDetails?.availability}}
         </div>
         <div class="labeldetail">
            <label>Copayment Fee:</label> {{claimDetails?.copaymentFee | currency}}
         </div>
         <div class="labeldetail">
            <label>Card Type:</label>  {{claimDetails?.paymentDetails?.cardType}}
         </div>
         <div class="labeldetail">
            <label>Card Last Four Digit Number:</label>  {{claimDetails?.paymentDetails?.lastFourDigit}}
         </div>
         <div class="labeldetail">
            <label>Transaction Id:</label> {{claimDetails?.paymentDetails?.transactionId}}
         </div>
         <div class="labeldetail">
            <label>Paid:</label> {{claimDetails?.isPaid ? 'Yes' : 'No'}}
         </div>
      </div>

      <div class="firstQuestion" *ngIf="claimDetails?.firstQestions?.length > 0">
         <h3>First Questions Answer</h3>
         <div class="table-wrapper">
            <table>
               <thead>
                  <tr>
                     <th>Question</th>
                     <th>Question Type</th>
                     <th>Answer</th>
                  </tr>
               </thead>
               
               <tr *ngFor="let item of claimDetails?.firstQestions">
                  <td title="Question">{{item?.question_details?.title}}</td>
                  <td title="Question Type">{{item?.question_details?.type}}</td>
                  <td title="Answer">{{item?.question_details?.type == "Yes/No" ? (item?.answer ? 'Yes' : 'No') : item?.answer}}</td>
               </tr>
            </table>
         </div>
        
       </div>
       <div class="additionalQuestion">
         <h3>Additional Questions Answer</h3>
         <div class="table-wrapper">
            <table>
               <thead>
                  <tr>
                     <th>Question</th>
                     <th>Question Type</th>
                     <th>Answer</th>
                  </tr>
               </thead>
               
               <tr *ngFor="let item of claimDetails?.additionalQuestions">
                  <td title="Question">{{item?.question_details?.title}}</td>
                  <td title="Question Type">{{item?.question_details?.show | titlecase}}</td>
                  <td title="Answer">
                     {{item?.question_details?.type === 'Yes/No' ? (item.answer ? 'Yes' : 'No') :
                     item?.question_details?.type === 'Date' ? (item?.answer | date: 'MMM-dd-YYYY') :
                     item?.answer}}
                  </td>
               </tr>
            </table>
         </div>
        
       </div>
       <div class="claim-questins">
         <h3>Claim Questions Answer</h3>
         <div class="table-wrapper">
            <table>
               <thead>
                  <tr>
                     <th>Question</th>
                     <th>Answer</th>
                  </tr>
               </thead>
               
               <tr *ngFor="let item of claimDetails?.answerDetails">
                  <td title="Question">{{item.claim_question_answer_details[0]?.quetion?.question}}</td>
                  <td title="Answer">
                     <p *ngFor="let answer of item?.claim_question_answer_details">{{answer?.answer}}</p>
                     <p *ngIf="data?.otherAnswer">{{data?.otherAnswer}}</p>
                  </td>
               </tr>
               <tr *ngIf="claimDetails?.issueDate">
                  <td title="Question"> When did you first notice the issue?</td>
                  <td title="Answer">{{claimDetails.issueDate | date : 'MMM-dd-YYYY'}}</td>
               </tr>
            </table>
         </div>
         
       </div> 
   </mat-dialog-content>
  
</div>